module.exports = __webpack_public_path__ + "static/img/2_1.29f3bd33.jpg";